import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, Transition as _Transition } from "vue"

const _hoisted_1 = {
  class: "ButtonDropdown",
  ref: "reference"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-down ml-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_the_button, {
      class: "primary small",
      style: _normalizeStyle(`${_ctx.isVisible ? 'background-color: rgba(30, 58, 138, var(--tw-bg-opacity))' : ''}`),
      onClick: _ctx.openDropdown
    }, {
      default: _withCtx(() => [
        (_ctx.isTable)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" ... ")
            ], 64))
          : _createCommentVNode("", true),
        (Boolean(_ctx.title))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
              _hoisted_2
            ], 64))
          : (Boolean(_ctx.icon))
            ? (_openBlock(), _createElementBlock("i", {
                key: 2,
                class: _normalizeClass(_ctx.icon)
              }, null, 2))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["style", "onClick"]),
    _createVNode(_Transition, { name: "tooltip" }, {
      default: _withCtx(() => [
        (_ctx.isVisible)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "ButtonDropdown__content",
              ref: "tooltip",
              style: _normalizeStyle({ position: _ctx.strategy, left: `${_ctx.x}px`, top: `${_ctx.y}px` })
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 512))
}